import { useEffect, useState } from "react";
import Loading from "./loading";
import useAuth from "../context/useAuth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash, faSearch } from '@fortawesome/free-solid-svg-icons';
import NavBar from "./NavBar";

function ConsultaDinamica() {
  const { logout } = useAuth();
  const [paginaCarregada, setPaginaCarregada] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [filters, setFilters] = useState([{ field: "", operator: "=", value: "" }]);
  const [results, setResults] = useState([]);
  const [availableFields, setAvailableFields] = useState([]);

  useEffect(() => {
    setPaginaCarregada(true);
    const tokenAcesso = process.env.REACT_APP_MONGO_token;

    fetch(process.env.REACT_APP_GETFIELDS, {
      method: "GET",
      headers: { "Content-Type": "application/json", token: tokenAcesso },
    })
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          setAvailableFields(data);
        } else {
          setAvailableFields([]);
        }
      })
      .catch(error => console.error("Erro ao buscar campos:", error.message));
  }, []);

  const updateFilter = (index, key, value) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const addFilter = () => {
    setFilters([...filters, { field: "", operator: "=", value: "" }]);
  };

  const removeFilter = (index) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const executeQuery = async () => {
    setCarregando(true);
    const tokenAcesso = process.env.REACT_APP_MONGO_token;

    const operatorMap = {
      "=": "igual",
      "contains": "contém",
      ">": "maior",
      "<": "menor",
      "$ne": "diferente"
    };

    const queryParams = filters
      .map(filter =>
        `campo=${encodeURIComponent(filter.field)}&operador=${operatorMap[filter.operator] || filter.operator}&valor=${encodeURIComponent(filter.value)}`
      )
      .join("&");

    const url = `${process.env.REACT_APP_CONSULTA_DINAMICA}?${queryParams}`;

    fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json", token: tokenAcesso }
    })
      .then(response => response.json())
      .then(data => {
        setResults(Array.isArray(data) ? data : []);
        setCarregando(false);
      })
      .catch(error => {
        console.error("Erro ao buscar dados:", error);
        setCarregando(false);
      });
  };

  const getFieldValue = (row, fieldPath) => {
    return fieldPath.split('.').reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""), row);
  };

  if (!paginaCarregada) {
    return <Loading />;
  }

  return (
    <div className="max-w-screen-2xl">
      <div className="menu">
        <NavBar />
        <div className="containerBox">
          <h2 className="text-3xl text-white font-bold mb-4">Consulta Dinâmica</h2>
          {filters.map((filter, index) => (
            <div key={index} className="filter-row">
              <select value={filter.field}
                className="rounded border border-solid border-neutral-300 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-neutral-400 outline-none transition duration-200 ease-in-out focus:z-[3] focus:border-primary  focus:outline-none"
                onChange={(e) => updateFilter(index, "field", e.target.value)}>
                <option value="" disabled >Selecione um campo</option>
                {availableFields.map((field, idx) => <option key={idx} value={field}>{field}</option>)}
              </select>
              <select value={filter.operator}
                className="m-2 rounded-md p-1 relative border border-solid border-neutral-300 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-neutral-400 outline-none transition duration-200 ease-in-out focus:z-[3] focus:border-primary  focus:outline-none"
                onChange={(e) => updateFilter(index, "operator", e.target.value)}>
                <option value="=">Igual</option>
                <option value="contem">Contém</option>
                <option value="maior">Maior que</option>
                <option value="menor">Menor que</option>
                <option value="diferente">Diferente de</option>
              </select>
              <input type="text" placeholder="Valor"
                className="m-2 rounded-md p-0.5 relative border border-solid border-neutral-300 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-neutral-400 outline-none transition duration-200 ease-in-out focus:z-[3] focus:border-primary  focus:outline-none"
                value={filter.value} onChange={(e) => updateFilter(index, "value", e.target.value)} />

              <button
                className="btn-delete  text-white"
                onClick={() => removeFilter(index)}><FontAwesomeIcon icon={faTrash} /></button>
            </div>
          ))}
          <button
            className="btn-add mr-60 bg-teal-500 hover:bg-teal-600 p-2 rounded-lg text-white"
            onClick={addFilter}><FontAwesomeIcon icon={faPlus} /> Adicionar Filtro</button>
          <button
            className="btn-search bg-teal-500 p-2 rounded-lg text-white hover:bg-teal-600"
            onClick={executeQuery}><FontAwesomeIcon icon={faSearch} /> Buscar</button>
          {carregando ? <p>Carregando...</p> : (
            <table className="min-w-full divide-gray-200 mb-3 text-white mt-16" style={{ backgroundColor: '#1E1E2E', borderRadius: '10px', border: 'solid', borderSpacing: '0', overflow: 'hidden' }}>
              <thead>
                <tr style={{ backgroundColor: '#27293D' }}>
                  <th className="px-3 py-2 text-white" style={{ backgroundColor: '#27293D' }}>Código</th>
                  <th className="px-3 py-2 text-white" style={{ backgroundColor: '#27293D' }}>CNPJ</th>
                  <th className="px-3 py-2 text-white" style={{ backgroundColor: '#27293D' }}>Nome Fantasia</th>
                  <th className="px-3 py-2 text-white" style={{ backgroundColor: '#27293D' }}>{filters[0].field}</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-black">
                {results.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="px-3 py-2 text-white" style={{ backgroundColor: '#27293D' }}>{row._id}</td>
                    <td className="px-3 py-2 text-white" style={{ backgroundColor: '#27293D' }}>{row.filial.cnpj}</td>
                    <td className="px-3 py-2 text-white" style={{ backgroundColor: '#27293D' }}>{row.filial.nomeFantasia}</td>
                    <td className="px-3 py-2 text-white" style={{ backgroundColor: '#27293D' }}>
                      {filters.length > 0 && filters[0].field ? getFieldValue(row, filters[0].field) : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default ConsultaDinamica;